"use strict";

define('evisions/promise',['bluebird', 'vertebrae', 'rs/error/error.manager', 'rs/errors'], function (Promise, Vertebrae, Err, RSError) {
  Promise.prototype.fail = function (fn) {
    return this.caught(function (e) {
      fn.apply(this, arguments);
      throw e;
    });
  };
  var done = Promise.prototype.done;
  Promise.prototype.done = function () {
    done.apply(this, arguments);
    return this;
  };
  Promise.prototype.ignoreErrors = function () {
    var argClone = [].slice.call(arguments);
    argClone.push(function () {
      throw RSError.IgnoredError();
    });
    return this.caught.apply(this, argClone);
  };
  Promise.prototype.ignore = Promise.prototype.ignoreErrors;
  function defer() {
    var resolve, reject, promise;
    promise = new Promise(function () {
      resolve = arguments[0];
      reject = arguments[1];
    });
    return {
      resolve: resolve,
      reject: reject,
      resolvetWith: function resolvetWith(val) {
        var that = this;
        return function () {
          that.resolve(val);
        };
      },
      rejectWith: function rejectWith(val) {
        var that = this;
        return function () {
          that.reject(val);
        };
      },
      then: function then() {
        return promise.then.apply(promise, arguments);
      },
      done: function done() {
        return promise.done.apply(promise, arguments);
      },
      fail: function fail() {
        return promise.fail.apply(promise, arguments);
      },
      promise: promise
    };
  }
  ;
  Promise.defer = defer;
  Promise.IgnoredError = RSError.IgnoredError;
  window.Promise = Promise;
  return Promise;
});

